var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QButtonGroup',{attrs:{"list":_vm.activeFilterOptions,"edit":true,"dense":"","noempty":""},model:{value:(_vm.activeFilter),callback:function ($$v) {_vm.activeFilter=$$v},expression:"activeFilter"}})}
var staticRenderFns = []

export { render, staticRenderFns }